export const meetingRoomModel = (data = {}) => ({
  uuid: data.uuid || "",
  code: data.code || "",
  name: data.name || "",
  capacity: data.capacity ?? null,
  officeUUID: data.office?.uuid || "",
  office: data.office || null,
  officeName: data.office?.name || "",
  companyUUID: data.company?.uuid || "",
  company: data.company || null,
  companyName: data.company?.name || "",
  picUserUUID: data.pic_user?.uuid || data.pic_user_uuid || "",
  picUser: data.pic_user || null,
  picUserName: data.pic_user?.name || "",
  imageUrl: data.image || "",
  description: data.description || "",
  isMuslimFriendly: Boolean(data.is_muslim_friendly),
  isServeDeck: Boolean(data.is_serve_deck),
  isActive: Boolean(data.is_active),
  amenities: data.amenities || [],
  amenityUUIDs: (data.amenities || []).map((item) => item.uuid),
  createdAt: data.created_at || "",
  updatedAt: data.updated_at || "",
});
